module.exports = __webpack_public_path__ + "static/media/ruby.d2e4cfb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Languages/img/ruby.svg
// module id = 120
// module chunks = 0